export default __webpack_public_path__ + "static/media/132045599_466846691437415_9201376729249084858_n.f244866f.jpg";